<template>
  <v-dialog width="500" v-model="showADRClassForm">
    <v-card>
      <v-card-title class="secondary white--text">
        <span> {{ editMode ? "Update" : "Add" }} ADR Class </span>

        <v-spacer></v-spacer>

        <v-btn icon @click="resetForm(), (showADRClassForm = false)">
          <v-icon class="white--text">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-form ref="ADRClassForm" v-if="showADRClassForm" v-model="isValid">
          <v-row class="my-0">
            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="ADR Class *"
                required
                :rules="[(val) => !!val || 'ADR Class is Required!']"
                hide-details="auto"
                v-model="formDetails.adr_no"
                :error-messages="formErrors.adr_no"
                @input="delete formErrors.adr_no"
              />
            </v-col>

            <v-col cols="12" class="Form-Columns">
              <InputField
                type="text"
                label="Description"
                hide-details="auto"
                v-model="formDetails.adr_description"
                :error-messages="formErrors.adr_description"
                @input="delete formErrors.adr_description"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          depressed
          :disabled="!isValid"
          @click="submitForm"
        >
          Submit
        </v-btn>

        <v-btn
          class="ml-2"
          color="secondary"
          v-if="!editMode"
          depressed
          @click="resetForm"
        >
          Reset
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import SelectField from "@/components/FormBaseComponents/SelectField.vue";

export default {
  components: {
    InputField,
    SelectField,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editADRClassID: {
      type: [Number, null],
      default: null,
    },
  },
  watch: {
    value(val) {
      if (val) {
        if (this.editMode) {
          this.getADRClassObject(this.editADRClassID);
        }
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    showADRClassForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      formDetails: {},
      formErrors: {},
      isTextInput: false,
      isValid: true,
    };
  },
  methods: {
    submitForm() {
      this.$bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.formDetails = {
          ...this.formDetails,
        };
        this.$api.adrClass
          .addADRClass(this.formDetails)
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "ADR Class added successfully!",
              color: "success",
            });
            this.resetForm();
            this.showADRClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't add ADR Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      } else {
        this.$api.adrClass
          .updateADRClass({ id: this.formDetails.id, data: this.formDetails })
          .then((res) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "ADR Class updated successfully!",
              color: "success",
            });
            this.resetForm();
            this.showADRClassForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Couldn't update ADR Class!",
              color: "error",
            });
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      if (this.$refs.ADRClassForm) {
        this.$refs.ADRClassForm.reset();
      }
      this.formDetails = {};
    },

    getADRClassObject(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.adrClass
        .getADRClassObject(id)
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.formDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
